export const paramsKey = {
  pageNumber: "pageNumber",
  pageSize: "pageSize",
  organizer: "organizer",
  resourceType: "resourceType",
  // locationIds: "locationIds",
  locations: "locations",
  categories: "categories",
  categoryOperator: "categoryOperator",
  capacity: "capacity",
  capacityValue: "capacityValue",
  status: "status",
  sortBy: "sortBy",
  textSearch: "textSearch",
};
